import styled from 'styled-components';
import { px, palette } from '@liasincontrol/ui-basics';

const Wrapper = styled.div<{ $showSpinButtons: boolean }>`
    display: grid;
    grid-template-columns: ${(p) => (p.$showSpinButtons ? `${px(48)} 1fr ${px(48)}` : `1fr`)};
    grid-gap: ${px(16)};
    align-items: center;
    justify-content: center;

    .dx-button-mode-contained {
        cursor: pointer;
        border-radius: ${px(6)};
        background-color: ${palette.primary4};
        border: ${px(2)} solid ${palette.primary4};
        position: relative;
        overflow: hidden;
        vertical-align: middle;
        width: ${px(48)};
        height: ${px(48)};
        line-height: 0;    
        padding: 0;
        outline: 0; 
        transition: background-color 0.3s ease, border - color 0.3s ease, color 0.3s ease;

        .dx-icon {
            color: ${palette.primary1b};
            font-size: 1.5rem;
        }

        &.dx-state-focused {
            background-color: ${palette.white};
            border-color: ${palette.primary1b};
            color: ${palette.primary1b};
        }

        &.dx-state-hover {
            background-color: ${palette.primary3};
            border-color: ${palette.primary3};
            color: ${palette.primary1b};
        }

        :hover {
            background-color: ${palette.primary3};
            border-color: ${palette.primary3};
            color: ${palette.primary1b};
        }
        :focus {
            background-color: ${palette.white};
            border-color: ${palette.primary1b};
            color: ${palette.primary1b};
        }
        :hover :focus, :active {
            background-color: ${palette.primary3};
            border-color: ${palette.primary3};
            color: ${palette.primary1b};
        } 
    }   
`;

const styledComponents = { Wrapper };

export default styledComponents;